import { Skeleton } from '@mui/material';
import { FC } from 'react';
import { PatientVerificationSummary } from '../../../../services/insurance/types/patient-verification-summary';
import { VerificationPriority } from '../../../../services/insurance/types/verification-priority';
import { VerificationSummary } from '../../../../services/insurance/types/verification-summary';
import { VerificationInProcessStatus } from '../../shared/styles';
import { PatientIvStatusButton, PatientIvStatusButtonProps } from './status-button';
import { PatientIvStatusButtonSelector } from './status-button-selector';
import { UnknownPatientIvStatusButton } from './unknown-status-button';

export interface PatientIvStatusButtonFactoryProps {
  loading?: boolean;
  patientId: number | undefined;
  locationId: number | undefined;
  verificationPriority: VerificationPriority;
  patientSummary: PatientVerificationSummary;
  selectedSummary: VerificationSummary | undefined;
}

export const PatientIvStatusButtonFactory: FC<PatientIvStatusButtonFactoryProps> = (props) => {
  const { loading, patientId, locationId, verificationPriority, patientSummary, selectedSummary } = props;

  if (loading) return <Skeleton variant="text" sx={{ fontSize: '22px', width: '100px' }} />;

  if (patientSummary.pendingIvPriority === verificationPriority)
    return (
      <PatientIvStatusButton
        text="Verification in Process"
        icon={<VerificationInProcessStatus />}
        patientFlow={{
          patientIvSummary: patientSummary,
          verificationPriority
        }}
      />
    );

  if (!locationId) return null;

  if (!selectedSummary)
    return (
      <UnknownPatientIvStatusButton
        patientId={patientId}
        locationId={locationId}
        verificationPriority={verificationPriority}
      />
    );

  const buttonProps = {
    selectedIvSummary: selectedSummary,
    patientFlow: {
      patientIvSummary: patientSummary,
      verificationPriority
    }
  } as Partial<PatientIvStatusButtonProps>;

  return <PatientIvStatusButtonSelector selectedIvSummary={buttonProps.selectedIvSummary} patientFlow={buttonProps.patientFlow} />;
};
